import { Component, Input } from '@angular/core';
import { NgIf } from '@angular/common';
import { NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'lib-tooltip',
    standalone: true,
    imports: [
        NgIf, NgbPopoverModule
    ],
    templateUrl: './tooltip.component.html',
    styleUrl: './tooltip.component.css'
})
export class TooltipComponent {
    @Input() tooltipText?: string;
}
